<template>
  <el-popover
    placement="top-start"
    trigger="click"
    v-bind="$attrs"
    ref="popover"
  >
    <template #default>
      <div class="d-flex justify-content-between mb-2">
        <div>Click to insert into the cursor position:</div>
        <div>
          <button
            @click="close"
            type="button"
            class="btn line-height-10 p-0 bg-gray-hover-200"
          >
            <i class="fas fa-times fa-sm fa-fw"></i>
          </button>
        </div>
      </div>
      <Picker
        :data="emojiIndex"
        @select="onSelect"
        :showPreview="false"
      ></Picker>
    </template>
    <template #reference>
      <slot>
        Emoji
      </slot>
    </template>
  </el-popover>
</template>

<script>
import data from 'emoji-mart-vue-fast/data/apple';
import {EmojiIndex, Picker} from 'emoji-mart-vue-fast';

export default {
  components: {
    Picker,
  },

  props: {
    multiple: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      emojiIndex: new EmojiIndex(data),
    };
  },

  methods: {
    /**
     * @param value
     * @emits select
     */
    onSelect(value) {
      this.$emit('select', value);
      !this.multiple && this.close();
    },

    close() {
      this.$refs.popover.doClose();
    },
  },
}
</script>

